import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'components/ui/table';
import Text from 'components/Text';
import { Customer } from 'types/common_types';
import { cn } from 'lib/utils';
import { ReactSVG } from 'react-svg';
import { edit_icon, view_icon } from 'asset/icons';
import { useNavigate } from 'react-router-dom';

interface CustomerTableProps {
  customers: Customer[];
  onEdit?: (customer: Customer) => void;
  onDeactivate?: (customer: Customer) => void;
}

const CustomerTable = ({ customers, onEdit, onDeactivate }: CustomerTableProps) => {
  const navigate = useNavigate();
  return (
    <div className='min-h-0'>
      <div className='rounded-xl border max-h-full overflow-y-auto'>
        <Table>
          <TableHeader>
            <TableRow className='hover:bg-transparent'>
              <TableHead className='px-4 text-black py-3 min-w-36'>Customer Name</TableHead>
              <TableHead className='text-black min-w-40'>Rooms</TableHead>
              <TableHead className='text-black min-w-40'>Stores</TableHead>
              <TableHead className='text-black min-w-40'>Audits</TableHead>
              <TableHead className='text-black min-w-40'>Active Audits</TableHead>
              <TableHead className='text-black min-w-40'>Status</TableHead>
              <TableHead className='text-black'>Action</TableHead>
            </TableRow>
          </TableHeader>

          <TableBody>
            {customers?.map((customer, index) => (
              <TableRow key={index} className='hover:bg-muted/50'>
                <TableCell className='px-4 py-3'>
                  <Text text={customer.customerName} className='text-muted-foreground font-medium' />
                </TableCell>

                <TableCell>
                  <Text text={customer?.rooms?.length ?? '0'} className='text-muted-foreground' />
                </TableCell>

                <TableCell>
                  <Text text={customer?.stores?.length ?? '0'} className='text-muted-foreground' />
                </TableCell>


                <TableCell>
                  {/* <Text text={customer.audits?.toString()?.length > 0 ? `${customer.audits} Completed` : '-'} className='text-muted-foreground' /> */}
                </TableCell>

                <TableCell>
                  <Text text={customer.isActiveAudit ? 'Yes' : 'No'} className='text-muted-foreground' />
                </TableCell>




                {/* Status */}
                <TableCell>
                  <span
                    className={cn(
                      'inline-flex items-center px-3 py-1 rounded-full text-xs font-medium',
                      customer?.isActive ? 'bg-primary text-white' : 'bg-primary/20 text-primary',
                    )}
                  >
                    {customer?.isActive ? 'Active' : 'In Active'}
                  </span>
                </TableCell>

                <TableCell>
                  <div className='flex gap-4'>
                    <div className='flex items-center gap-1 cursor-pointer' onClick={() => navigate(`/view-customer`, { state: customer })}>
                      <Text text='View' className='text-muted-foreground' />
                      <ReactSVG src={view_icon} />
                    </div>

                    <div className='flex items-center gap-1 cursor-pointer' onClick={() => onEdit?.(customer)}>
                      <Text text='Edit' className='text-muted-foreground' />
                      <ReactSVG src={edit_icon} />
                    </div>

                    <div
                      className='flex items-center gap-1 cursor-pointer text-destructive hover:text-destructive'
                      onClick={() => onDeactivate?.(customer)}
                    >
                      <Text text={customer?.isActive ? 'Deactivate' : 'Activate'} className='text-destructive' />
                      {/* <ReactSVG src={delete_icon} /> */}
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            ))}

            {customers?.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className='py-10 text-center'>
                  <Text text='No customers found.' className='text-muted-foreground' />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default CustomerTable;
